export function blurCheckboxTarget(target: EventTarget | null): void {
  if (
    target !== null &&
    'type' in target &&
    target.type === 'checkbox' &&
    'blur' in target &&
    typeof target.blur === 'function'
  ) {
    target.blur();
  }
}
